import { FileUpload } from "components";
import { Typography } from "@mui/material";
import localisations from "../../../localisation";

type SelectFileProps = {
    selectedFile: File | undefined;
    handleImportFileChange: (file: File | undefined) => void;
};

export default function SelectFileStage(props: SelectFileProps) {
    const { heading, blurb } = localisations.stockTransferImport.stages.selectFile;

    return (
        <>
            <Typography variant="h5" gutterBottom>
                {heading}
            </Typography>

            <Typography variant="body1" gutterBottom>
                {blurb}
            </Typography>

            <FileUpload
                id="stock-transfer-file-upload"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                onSelect={props.handleImportFileChange}
                file={props.selectedFile}
            />
        </>
    );
}
